import { Component } from '@angular/core';
import { EventBusService, EventType, ATMEventData } from '../services/eventbus.service';


@Component({
  selector: 'app-outage',
  templateUrl: './outage.component.html',
  styleUrls: ['./outage.component.scss']
})
export class OutageComponent {

  outageMessage: string|null = null;

  constructor(private eventBusService: EventBusService) {
    this.eventBusService.getEventBus(EventType.SET_OUTAGE_EVENT )
      .subscribe((eventData: ATMEventData) => this.outageMessage = eventData.data);
    this.eventBusService.getEventBus(EventType.CLEAR_OUTAGE_EVENT)
      .subscribe((eventData: ATMEventData) => this.outageMessage = null);
  }

}
